import React, { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./auth.css";
import companyLogo from "../../Assets/forbeslogo.png";

const BASE_URL = process.env.REACT_APP_BASE_URL;

const SignUp = () => {
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleSignUp = async () => {
    if (token.length < 4 || token.length > 5) {
      toast.error("Token number must be 4–5 characters long");
      return;
    }

    if (password.length < 4) {
      toast.error("Password must be at least 4 characters long");
      return;
    }

    try {
      const response = await fetch(`${BASE_URL}/api/auth/signup`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token_no: token, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        toast.error(data.message || "Signup failed");
      } else {
        toast.success("Signup successful! Redirecting...");
        setTimeout(() => navigate("/signin"), 1500);
      }
    } catch (error) {
      console.error("Signup error:", error);
      toast.error("Server error. Please try again later.");
    }
  };

  return (
    <div className="auth-container">
      <div className="background-overlay" />
      <img src={companyLogo} alt="Company Logo" className="logo-container" />
      <div className="auth-content">
        <div className="welcome-text">
          <h1>Create Your Account</h1>
        </div>

        <div className="auth-box">
          <div className="input-container">
            <input
              type="text"
              placeholder="Enter Token Number"
              maxLength="5"
              value={token}
              onChange={(e) => setToken(e.target.value.trim())}
            />
          </div>

          <div className="input-container" style={{ position: "relative" }}>
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Create Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              style={{ paddingRight: "2.5rem" }}
            />
            <span
              onClick={() => setShowPassword((prev) => !prev)}
              style={{
                position: "absolute",
                right: "10px",
                top: "50%",
                transform: "translateY(-50%)",
                cursor: "pointer",
                fontSize: "1rem",
                color: "#333",
              }}
              title={showPassword ? "Hide Password" : "Show Password"}
            >
              {showPassword ? "👁︎" : "👁️"}
            </span>
          </div>

          <button
            onClick={handleSignUp}
            disabled={
              token.length < 4 || token.length > 5 || password.length < 4
            }
          >
            SIGN UP
          </button>

          <p className="redirect-message">
            Already have an account?{" "}
            <Link to="/signin" className="signin-link">
              Sign In
            </Link>
          </p>
        </div>
      </div>
    </div>
  );
};

export default SignUp;
